/**
 * Gordonix varyant görsel hızlandırma
 * Sadece seçili varyant (+ komşu) — tüm galeriyi eager çekme (sayfa kilitlenmesin)
 */
(function () {
  var warmed = new Set();

  function absUrl(u) {
    if (!u) return "";
    try {
      return new URL(u, window.location.origin).href;
    } catch (e) {
      return u;
    }
  }

  function warmUrl(url, priority) {
    url = absUrl(url);
    if (!url || warmed.has(url)) return;
    warmed.add(url);
    var img = new Image();
    img.decoding = "async";
    if (priority && "fetchPriority" in img) img.fetchPriority = priority;
    img.src = url;
  }

  function parsePreloadMap() {
    var el = document.querySelector("[data-gordonix-preload-map]");
    if (!el) return { variants: {} };
    try {
      return JSON.parse(el.textContent || "{}");
    } catch (e) {
      return { variants: {} };
    }
  }

  function currentVariantId() {
    var input =
      document.querySelector('product-form-component input[name="id"]') ||
      document.querySelector('form[action*="/cart/add"] input[name="id"]') ||
      document.querySelector('input[name="id"]');
    return input && input.value ? String(input.value) : null;
  }

  function warmVariantFromMap(id, priority) {
    var map = parsePreloadMap();
    var urls = (map.variants && map.variants[String(id)]) || [];
    // En fazla ilk 3 görsel
    urls.slice(0, 3).forEach(function (u, i) {
      warmUrl(u, i === 0 ? priority || "high" : "low");
    });
  }

  function onVariantLikely() {
    var id = currentVariantId();
    if (id) warmVariantFromMap(id, "high");
  }

  document.addEventListener(
    "pointerenter",
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest("variant-picker, fieldset, .variant-option")) return;
      setTimeout(onVariantLikely, 0);
    },
    true
  );

  document.addEventListener(
    "pointerdown",
    function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      if (!t.closest("variant-picker, fieldset, .variant-option")) return;
      setTimeout(onVariantLikely, 0);
    },
    true
  );

  document.addEventListener("change", function (e) {
    if (e.target && e.target.closest && e.target.closest("variant-picker")) {
      onVariantLikely();
    }
  });

  document.addEventListener("product:selected", function (e) {
    var id =
      (e.detail && e.detail.selectedVariant && e.detail.selectedVariant.id) ||
      (e.detail && e.detail.variant && e.detail.variant.id);
    if (id) warmVariantFromMap(String(id), "high");
    else onVariantLikely();
  });

  function start() {
    onVariantLikely();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();
